function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".workflow_svg__a{fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"));

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  className: "workflow_svg__a",
  cx: 12,
  cy: 6,
  r: 3
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "workflow_svg__a",
  height: 5,
  rx: 2,
  width: 8,
  x: 2,
  y: 16
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  className: "workflow_svg__a",
  height: 5,
  rx: 2,
  width: 8,
  x: 14,
  y: 16
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "workflow_svg__a",
  d: "M6 16v-2a2 2 0 012-2h8a2 2 0 012 2v2M12 9v3"
});

var SvgWorkflow = function SvgWorkflow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "#fff",
    stroke: "#002E69"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5);
};

export default SvgWorkflow;